import Rails from "@rails/ujs"

$(document).on("turbolinks:load",function(){
	Window.totem_global.modal_sleep = false;
	$("#function_8_1").each(function(form) {
		var that = this;
		$(this).find('table td.day').click(function(){
			if(!Window.totem_global.modal_sleep)
			{	Window.totem_global.modal_sleep = true;
				$('#to_submit_date').val($(this).data('day'));
				Rails.fire(that, 'submit');
			}
		});
	}); 
});